/*api
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { LaundryRecDetail } from '../../../interfaces/masters/laundryrecdetail';

@Injectable()
export class LaundryRecDetailApi {
  private readonly apiController: string = 'laundryrecdetail';
  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
    
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  listReceivedBy(url: string, options?: any): Observable<any[]> {
    
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }
  getById(url : string, options?: any): Observable<LaundryRecDetail[]> {
    debugger;
     return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
    
  }
   dashboardList(url: string, options?: any):Observable<any[]>
  {
 return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  add(url:string, data: LaundryRecDetail[]):Observable<any>{
    debugger;
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post( url, data, header);
  }

  update(url:string, data: LaundryRecDetail):Observable<any>{
    debugger;
    // let header = new HttpHeaders();
    // header.append('Content-Type', 'applications/json');
    // header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }
}
